import { centsToInteger } from '@10xlabs/utils'
import { DEFAULT_KREDITS_SETTINGS_VALUES } from 'features/BusinessClients/utils'
import { IBusinessSiteContact, IBusinessSitesFilters, INewBusinessSiteValues } from 'features/BusinessSites/types'
import { BusinessClientSuggestion } from 'gql/generated/graphql'
import {
  GTBusinessSite,
  GTBusinessSitesInput,
  GTChangeBusinessClientSiteKreditSettingsInput,
  GTFrequencyUnitInput
} from 'gql/types.generated'
import { sanitizePrice } from 'utils/math'
import { filterEmptyValue } from 'utils/object'
import { getQueryString } from 'utils/route'

export const mapContactsToMutation = (contacts: IBusinessSiteContact[]): IBusinessSiteContact[] => {
  return contacts.map(
    ({ id, name, phone, secondaryPhone, email, secondaryEmail }) =>
      filterEmptyValue({
        id,
        name,
        phone,
        secondaryPhone,
        email,
        secondaryEmail
      }) as IBusinessSiteContact
  )
}

export const mapContactsToForm = (contacts: IBusinessSiteContact[]): IBusinessSiteContact[] => {
  return contacts.map(
    ({ id, name, phone, secondaryPhone, email, secondaryEmail }) =>
      ({
        id: id ?? '',
        name: name ?? '',
        phone: phone ?? '',
        secondaryPhone: secondaryPhone ?? '',
        email: email ?? '',
        secondaryEmail: secondaryEmail ?? ''
      } as IBusinessSiteContact)
  )
}

export const mapFiltersToSearchQueryString = (filters: IBusinessSitesFilters, pageNb = 1): string => {
  return getQueryString({
    page: pageNb,
    clientId: filters.businessClient?.id
  })
}

export const mapSearchToFiltersValues = (
  searchQueries: Record<string, string>,
  { businessClient }: { businessClient: BusinessClientSuggestion | null }
): IBusinessSitesFilters => {
  return {
    businessClient: businessClient || {
      id: searchQueries.clientId || '',
      name: ''
    }
  }
}

export const mapSearchQueryToInput = (searchQueries: Record<string, string>): GTBusinessSitesInput => {
  return filterEmptyValue({
    clientID: searchQueries.clientId || null
  })
}

export const mapBusinessSiteToForm = (businessSite: GTBusinessSite): INewBusinessSiteValues => {
  const data: INewBusinessSiteValues = {
    name: businessSite.name,
    client: {
      id: businessSite.client.id || '',
      name: businessSite.client.name || ''
    },
    city: {
      id: businessSite.city?.id || '',
      name: businessSite.city?.name || '',
      stateCode: ''
    },
    contacts: mapContactsToForm(businessSite.contacts as IBusinessSiteContact[]),
    kreditsSettings: businessSite.kreditsSettings
      ? {
          categories: businessSite.kreditsSettings.map((category) => ({
            name: category.name.toString(),
            amount: centsToInteger(category.amount).toString(),
            canEditName: false,
            frequency: {
              unit: category.frequency.unit,
              value: category.frequency.value.toString()
            }
          }))
        }
      : DEFAULT_KREDITS_SETTINGS_VALUES
  }
  return data
}

export const mapFormValuesToKreditSettingsMutation = (
  values: INewBusinessSiteValues,
  siteId: string,
  cliendId: string
): GTChangeBusinessClientSiteKreditSettingsInput => {
  const kreditsSettings: INewBusinessSiteValues['kreditsSettings'] = values.kreditsSettings
  const data: GTChangeBusinessClientSiteKreditSettingsInput = {
    siteID: siteId,
    id: cliendId,
    categories: kreditsSettings.categories.map((category) => ({
      name: Number(category.name),
      amount: sanitizePrice(Number(category.amount) * 100, true),
      frequency: {
        unit: category.frequency.unit as unknown as GTFrequencyUnitInput,
        value: Number(category.frequency.value)
      }
    }))
  }

  return data
}
